module.exports = __webpack_public_path__ + "img/time-line-notification.662cdc7d.svg";